module.exports = __webpack_public_path__ + "static/media/rejected-order.73b33d68.svg";